// src/components/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light">
      <h1 className="display-4 fw-bold text-danger">404</h1>
      <p className="lead text-secondary">Page not found or access denied.</p>
      <Link to="/" className="btn btn-dark mt-3">
        Go to Home Page
      </Link>
    </div>
  );
};

export default NotFound;
